module.exports = __webpack_public_path__ + "static/media/firenze.7aa49fd4.jpeg";